import { Box, Typography } from '@mui/material';
import { themeColors } from 'toolkit/styles/colors';

interface SpeechBubbleProps {
  name?: string;
  time?: string;
  text?: string;
  anchor: 'left' | 'right';
}

function bubbleHeaderLabel(name?: string, time?: string): string | null {
  if (name && time) {
    return `${name} · ${time}`;
  }
  if (name) {
    return name;
  }
  if (time) {
    return `Unknown · ${time}`;
  }
  return null;
}

const SpeechBubble = ({ name, time, text, anchor }: SpeechBubbleProps) => {
  const header = bubbleHeaderLabel(name, time);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '30%',
        maxWidth: '60%',
        backgroundColor:
          anchor === 'left'
            ? themeColors.surfaceSecondary
            : themeColors.inverseOnSurface,
        alignSelf: anchor === 'left' ? 'start' : 'end',
      }}
    >
      {header ? <Typography variant="titleSmall">{header}</Typography> : null}
      <Typography component="div" variant="bodyLarge">
        {text}
      </Typography>
    </Box>
  );
};

export default SpeechBubble;
